// extracted by mini-css-extract-plugin
module.exports = {"breakingNews":"ahead-breaking-news_breakingNews__2rM61","buttonGroup":"ahead-breaking-news_buttonGroup__fZbKY"};